/**
 * 인증이 무너진 순간을 앱 전체에 알리는 한 줄짜리 통로.
 *
 * ⚠ **왜 이벤트인가.** 401 과 403 `pin_required` 는 **어느 요청에서나** 올 수 있다 —
 * 특히 PIN 은 서버가 재기동하면 일하던 중에 다시 요구된다. 그런데 그 응답을 받는
 * 곳은 목록 화면이고, 로그아웃하거나 키패드를 띄울 권한은 세션 쪽에 있다.
 *
 * TanStack Query 의 캐시 오류 처리기는 컨텍스트 밖에서 만들어지므로 훅을 부를 수
 * 없다. 그래서 아주 얇은 통로를 하나 두고, 세션이 거기에 귀를 댄다.
 *
 * ⚠ **화면마다 따로 처리하지 않는 것이 요점이다.** 흩어 놓으면 언젠가 한 화면을
 * 빠뜨리고, 빠뜨린 그 화면에서 PIN 만 안 푼 사람이 로그아웃당한다.
 */
import type { ApiFailureKind } from '@/api/errors'

type Listener = (kind: ApiFailureKind) => void

let listener: Listener | null = null

/** 세션이 부른다. 하나뿐이라 등록도 하나다. */
export function onAuthFailure(fn: Listener): () => void {
  listener = fn
  return () => {
    if (listener === fn) listener = null
  }
}

/** 오류 처리기가 부른다. */
export function reportAuthFailure(kind: ApiFailureKind): void {
  listener?.(kind)
}
